import { createClient } from '@supabase/supabase-js';

// Clean Supabase client with minimal auth config to prevent lock conflicts
export const supabase = createClient(
  'https://dngfoiurhphjpsvaeuut.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRuZ2ZvaXVyaHBoanBzdmFldXV0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc4MDg3NjEsImV4cCI6MjA4MzM4NDc2MX0.HEGbJoThHbpGXyAE8A1vcQVaztIVFNkw3VbqjvPRQAA',
  {
    auth: {
      autoRefreshToken: false, // Disable auto-refresh to prevent lock conflicts
      persistSession: true,
      detectSessionInUrl: false
    }
  }
);
